import parsePhoneNumber, { CountryCode } from 'libphonenumber-js';

const TEAMS_CALL_URL = 'https://teams.microsoft.com/l/call/0/0';

export function normaliseTeamsPhoneNumber(
  phoneNumber?: string,
  country?: string
): string | null {
  if (!phoneNumber) {
    return null;
  }

  const fallbackPhoneNumber = normaliseInternationalPhoneNumber(phoneNumber);

  try {
    const parsedNumber = country
      ? parsePhoneNumber(phoneNumber, {
          defaultCountry: country as CountryCode,
        })
      : parsePhoneNumber(phoneNumber);

    return parsedNumber.isValid() ? parsedNumber.number : fallbackPhoneNumber;
  } catch {
    return fallbackPhoneNumber;
  }
}

export function normaliseInternationalPhoneNumber(
  phoneNumber: string
): string | null {
  const trimmedNumber = phoneNumber.trim();
  const digits = trimmedNumber.replace(/\D/g, '');
  if (!digits) {
    return null;
  }

  if (trimmedNumber.startsWith('+')) {
    return `+${digits}`;
  }

  if (trimmedNumber.startsWith('00') && digits.length > 2) {
    return `+${digits.slice(2)}`;
  }

  return null;
}

export function buildTeamsCallUrl(
  phoneNumber: string,
  topicName: string
): string {
  return `${TEAMS_CALL_URL}?users=4:${encodeURIComponent(phoneNumber)}&topicName=${encodeURIComponent(topicName)}`;
}
